import {
  SystemStyleObject,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react'
import {
  Ellipsis,
  EmptyTablePlaceholder,
  TableSkeleton,
} from 'brokertslib/src/components'
import { FlexGroupGridItem } from 'BrokerTsLib/src/dtos'
import {
  ColumnDefinition,
  ColumnsDefinition,
} from 'brokertslib/src/interfaces/columnsDefinition'
import { useContext } from 'react'

import { Loading } from '@/components/Loading'

import { flexGroupListContext } from '../../pages/flex-group/list'
import { FlexGroupLink } from '../shared/FlexGroupLink'

export const FlexGroupListNameColumn: ColumnDefinition<FlexGroupGridItem> = {
  key: 'name',
  name: 'Název',
  cellExpr: (item) => (
    <FlexGroupLink
      sx={{ color: 'primary.500', fontWeight: 'medium', whiteSpace: 'nowrap' }}
      id={item.id}
      name={item.name}
    />
  ),
}

export const FlexGroupListDescriptionColumn: ColumnDefinition<FlexGroupGridItem> =
{
  key: 'description',
  name: 'Popis',
  cellExpr: (item) => <Ellipsis>{item.description || '-'}</Ellipsis>,
}

export const FlexGroupListDefaultColumns = [
  FlexGroupListNameColumn,
  FlexGroupListDescriptionColumn,
]

export const FlexGroupList = ({
  columnsDefinition = FlexGroupListDefaultColumns,
  flexGroups,
  sx,
}: {
  columnsDefinition?: ColumnsDefinition<FlexGroupGridItem>
  sx?: SystemStyleObject
  flexGroups: Array<FlexGroupGridItem>
  withPaginator?: boolean
}) => {
  const { pageSize, loading } = useContext(flexGroupListContext)

  return (
    <Table variant="striped" sx={sx}>
      <Thead>
        <Tr>
          {columnsDefinition &&
            columnsDefinition.map((column) => (
              <Th
                key={column.key}
                _empty={{ w: 0, p: 0 }}
                {...column.headerCellProps}
              >
                {column.name}
              </Th>
            ))}
        </Tr>
      </Thead>

      <Tbody>
        {loading && <Loading></Loading>}
        <TableSkeleton
          rowsCount={pageSize}
          colSpan={columnsDefinition.length}
          isLoaded={!loading}
        >
          <EmptyTablePlaceholder
            text='Žádné flexibilní skupiny k zobrazení'
            colSpan={columnsDefinition.length}
          >
            {flexGroups.map((flexGroup) => {
              return (
                <Tr key={flexGroup.id}>
                  {columnsDefinition &&
                    columnsDefinition.map((column) => (
                      <Td
                        key={column.key}
                        _empty={{ p: 0 }}
                        {...column.cellProps}
                      >
                        {column.cellExpr(flexGroup) || ''}
                      </Td>
                    ))}
                </Tr>
              )
            })}
          </EmptyTablePlaceholder>
        </TableSkeleton>
      </Tbody>
    </Table>
  )
}
